module.exports = __webpack_public_path__ + "img/header-1.faa697ce.png";